import { type ObjectTreeItemType, useObjectTree } from '@/entities/ObjectsTree'
import { useHelpers, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useTreeMove } from './api'
import { sortBy } from 'lodash'

export const useModel = () => {
  const tree = useObjectTree()
  const { removeTreeElementById } = useHelpers()
  const { addError } = useNotification()
  const { trs } = useTranslate()
  const api = useTreeMove()
  const { updateCounter } = useHelpers()

  /**
   * Функция вставки объекта
   */
  const paste = async () => {
    const targetObject = tree.contextObject as ObjectTreeItemType

    if (
      tree.cutObjects.some((item: ObjectTreeItemType) => targetObject.parents.includes(item.id))
    ) {
      addError(trs('itf.object_not_moved'))
    } else {
      await api.move({
        target: targetObject.id,
        items: tree.cutObjects.map((item: ObjectTreeItemType) => item.id),
      })

      tree.cutObjects.forEach((item: ObjectTreeItemType) => {
        removeTreeElementById(tree.objects, item.id)
      })

      if (targetObject.children.length) {
        targetObject.children = sortBy([...targetObject.children, ...tree.cutObjects], 'name')
      } else {
        targetObject.child_count = { ...updateCounter(tree.cutObjects, targetObject.child_count) }
      }
    }

    tree.cutObjects = []
    tree.contextObject = null
  }

  /**
   * Функция перемещения объекта
   * @param targetObject
   * @param objects
   */
  const move = async (targetObject: ObjectTreeItemType, objects: ObjectTreeItemType[]) => {
    if (objects.some((item: ObjectTreeItemType) => targetObject.parents.includes(item.id))) {
      addError(trs('itf.object_not_moved'))
    } else {
      await api.move({
        target: targetObject.id,
        items: objects.map((item: ObjectTreeItemType) => item.id),
      })

      objects.forEach((item: ObjectTreeItemType) => {
        removeTreeElementById(tree.objects, item.id)
      })

      if (targetObject.children.length) {
        targetObject.children = sortBy([...targetObject.children, ...objects], 'name')
      } else {
        targetObject.child_count = { ...updateCounter(objects, targetObject.child_count) }
      }
    }
  }

  return {
    paste,
    move,
  }
}
